
import { useState } from "react";
import { api } from "../../../../utils/api";
import { LoginHelper } from "../../../../utils/LoginHelper";
import Button from "../../../common/button/Button";
import { ProfileSection } from "../common/ProfileSection";
import FieldText from "../form/FieldText";

export default function ProfileOtherAction({ profileId }) {
	const [isOpen, setIsOpen] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [errorMessage, setErrorMessage] = useState("");
	const [reportMessage, setReportMessage] = useState("");
	const [resultMessage, setResultMessage] = useState("");

	const handleTextChange = (e) => {
		setReportMessage(e.target.value);
	};

	const handleReport = () => {
		setIsLoading(true);
		setErrorMessage("");
		setResultMessage("");
		api.reportProfile({
			token: LoginHelper.getToken(),
			profile_id: profileId,
			message: reportMessage,
		})
			.then(() => {
				setIsLoading(false);
				setResultMessage("گزارش با موفقیت ثبت شد.");
			})
			.catch((err) => {
				setIsLoading(false);
				setErrorMessage("ثبت گزارش با مشکل مواجه شد.");
				if (err && err.data) {
					setErrorMessage(err.data.message);
				}
			});
	};

	if (profileId == LoginHelper.getProfileId()) {
		return null;
	}

	if (!isOpen) {
		return (
			<div className="flex justify-end">
				<button
					type="button"
					className="font-Vazir-600 text-[13px] text-error hover:underline border-0 bg-transparent cursor-pointer p-0"
					onClick={() => setIsOpen(true)}
				>
					گزارش تخلف
				</button>
			</div>
		);
	}

	return (
		<ProfileSection title="گزارش پروفایل">
			<p className="text-[#4B5155] font-Vazir-600 text-[14px] mb-3">
				آیا از ثبت این گزارش مطمئن هستید؟
			</p>
			<FieldText
				className="font-Vazir-800"
				text={reportMessage}
				onChange={handleTextChange}
			/>
			<div className="flex flex-wrap items-center gap-2 mt-4">
				<button
					type="button"
					className="font-Vazir-600 text-[13px] text-midGray px-4 py-2 rounded-xl border border-[#E2E8F0] bg-white hover:bg-lightCta cursor-pointer"
					onClick={() => setIsOpen(false)}
				>
					انصراف
				</button>
				<div className="min-w-[50px] h-[30px]">
					<Button
						onClick={() => {
							handleReport();
						}}
						label={"ثبت گزارش"}
						isLoading={isLoading}
						color="#CC0000"
						textColor="#ffffff"
					/>
				</div>
				{resultMessage ? (
					<span className="text-[#008000] font-Vazir-400 text-[13px]">{resultMessage}</span>
				) : null}
				{errorMessage ? (
					<span className="text-error font-Vazir-400 text-[13px]">{errorMessage}</span>
				) : null}
			</div>
		</ProfileSection>
	);
}
